/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Meta_TitleInputs */

const en_svc_rag_meta_title = /** @type {(inputs: Svc_Rag_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG Development Services — Custom AI Knowledge Bases | Lindevo`)
};

const lv_svc_rag_meta_title = /** @type {(inputs: Svc_Rag_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG izstrāde un AI zināšanu bāzes uzņēmumiem | Lindevo`)
};

/**
* | output |
* | --- |
* | "RAG Development Services — Custom AI Knowledge Bases \| Lindevo" |
*
* @param {Svc_Rag_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_meta_title = /** @type {((inputs?: Svc_Rag_Meta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Meta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_meta_title(inputs)
	return en_svc_rag_meta_title(inputs)
});